import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';

const Wrapper = styled.div`
  position: absolute;
  bottom: -50px;
  z-index: 10;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  padding: 5px;
  background: ${theme.colors.light};
  border: 1px solid ${theme.colors.medium};
  border-radius: 5px;
  color: ${theme.colors.mediumlight};
  box-shadow: ${theme.shadows.default};
`;

function FloatingToolbar({ children }) {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  );
}

export default FloatingToolbar;
